import { createApp } from "vue";
import App from "./App.vue";
import { Configuration } from "./Configuration/index";
import router from "./router";

// oh-vue-icons
import { OhVueIcon, addIcons } from "oh-vue-icons";
import { FaTrash } from "oh-vue-icons/icons"; // <-- Delete icon

addIcons(FaTrash);

const configuration = new Configuration();
window.configuration = configuration;

const app = createApp(App);

// Register the icon globally
app.component("v-icon", OhVueIcon);

app.use(router).mount("#app");
